/**
 * Utility functions for handling filenames
 */

/**
 * Extracts the base filename without extension
 * @param filename - The full filename with extension
 * @returns The filename without extension
 */
export const getFileBaseName = (filename: string): string => {
  if (!filename) return '';
  
  // Get the last part after any path separators
  const baseName = filename.split(/[\\/]/).pop() || '';
  
  // Remove extension by finding the last dot
  const lastDotIndex = baseName.lastIndexOf('.');
  if (lastDotIndex === -1) return baseName; // No extension found
  
  return baseName.substring(0, lastDotIndex);
};

/**
 * Gets the default name for a group based on the first file
 * @param files - Array of files
 * @returns The base name of the first file, or empty string if no files
 */
export const getDefaultGroupName = (files: { name: string }[]): string => {
  if (!files || files.length === 0) return '';

  return getFileBaseName(files[0].name);
};

/**
 * Extracts the prefix before the last dash in a filename (for auto-grouping)
 * Example: "file1-S.mp4" -> "file1", "my-file-W.mp4" -> "my-file"
 * @param filename - The full filename
 * @returns The prefix before the last dash, or the full base name if no dash found
 */
export const getFilenamePrefix = (filename: string): string => {
  const baseName = getFileBaseName(filename);
  const lastDashIndex = baseName.lastIndexOf('-');

  if (lastDashIndex === -1) {
    return baseName;
  }

  return baseName.substring(0, lastDashIndex);
};
